module.exports = __webpack_public_path__ + "fonts/OpenSans-Light.0c991212.woff";